import { FunctionComponent, useState } from 'react'
import styles from './groupInformation.module.scss'
import Title from '@/components/_custom/Title/title'
import UserInput from '@/components/_custom/UserInput/userInput'
import { Role } from '@/types/Role'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useTranslation } from 'react-i18next'
import { DaycareGroup, DaycareGroupType } from '@/types/DaycareGroup'
import EditGroupInformationDialog from './Dialog/editGroupInformationDialog'
import ValidDeleteDaycareGroupDialog from './Dialog/deleteGroupDialog'
import CountrySelect from '@/components/_custom/CountrySelect/countrySelect'

interface GroupInformationProps {
    role?: Role
    group?: DaycareGroup
    refetchGroups: () => void
}

const GroupInformation: FunctionComponent<GroupInformationProps> = ({ role, group, refetchGroups }) => {
    const { t } = useTranslation()

    const [isEditGroupInformationDialogOpen, setEditGroupInformationDialogOpen] = useState<boolean>(false)
    const [isDeleteGroupDialogOpen, setDeleteGroupDialogOpen] = useState<boolean>(false)

    function convertType(type?: DaycareGroupType): string {
        switch (type) {
            case DaycareGroupType.agglomeration:
                return t('agglomeration')
            case DaycareGroupType.association:
                return t('association')
            case DaycareGroupType.city:
                return t('city')
            case DaycareGroupType.private:
                return t('private')
            case DaycareGroupType.community:
                return t('community')
            case DaycareGroupType.county:
                return t('county')
            default:
                return ''
        }
    }

    return (
        <div className={styles.Container}>
            <div className={styles.Title}>
                <Title text={t('groupInformation')} />
            </div>
            <div className={styles.GroupInformations}>
                <div className={styles.InputContainer}>
                    <UserInput
                        label={t('name')}
                        value={group?.name}
                        readOnly
                        format={'pascal'}
                        className={styles.UserInput}
                    />
                    <div className={styles.UserInput}>
                        <CountrySelect country={group?.country || ''} readOnly />
                    </div>
                </div>
                <div className={styles.InputContainer}>
                    <UserInput
                        label={t('location')}
                        value={group?.location}
                        readOnly
                        format={'upper'}
                        className={styles.UserInput}
                    />
                    <UserInput
                        label={t('type')}
                        value={convertType(group?.type)}
                        readOnly
                        format={'pascal'}
                        className={styles.UserInput}
                    />
                </div>
                {role === Role.cald && (
                    <div className={styles.ButtonContainer}>
                        <ButtonTextIcon
                            type={'edit'}
                            onClick={() => setEditGroupInformationDialogOpen(true)}
                            className={styles.Button}
                        />
                        {group && isEditGroupInformationDialogOpen && (
                            <EditGroupInformationDialog
                                open={isEditGroupInformationDialogOpen}
                                handleClose={() => setEditGroupInformationDialogOpen(false)}
                                group={group}
                                refetchGroups={refetchGroups}
                            />
                        )}
                        <ButtonTextIcon
                            type={'delete'}
                            onClick={() => setDeleteGroupDialogOpen(true)}
                            className={styles.Button}
                        />
                        {group && isDeleteGroupDialogOpen && (
                            <ValidDeleteDaycareGroupDialog
                                open={isDeleteGroupDialogOpen}
                                handleClose={() => setDeleteGroupDialogOpen(false)}
                                groupId={group.id}
                                refetchGroups={refetchGroups}
                            />
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default GroupInformation
